// pages/PrivateJet/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import PickYourPrivateJet from "../../components/Investments/PickYourPrivateJet";
import RoiInvestorBenefits from "../../components/Investments/RoiInvestorBenefits";
import { PRIVATE_JET_PAGE } from "../../data/privateJet";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import { Box, Button, Dialog, DialogContent, Grid, IconButton, Modal, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BookaCallEnquiry from '../../components/Investments/BookaCallEnquiry';
import BookaCallEnquiryForm from '../../components/Investments/BookaCallEnquiryForm';
import InvestmentSimulatorFlow from "../../components/Investments/CostCalculatore";
import { getPrivateJetList, getPrivateJetAdd } from '../../redux/slices/common';
import { useDispatch, useSelector } from '../../redux/store'
import CancelIcon from '@mui/icons-material/Cancel';
import AfterFormSubmit from "../../components/Investments/AfterFormSubmit"
import { openWhatsAppChat } from "../../utils/onWhatsApp";
import InvestNow from "../../components/investNow";
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function PrivateJet({ meta }) {
  const HEADER_OFFSET = 88;
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const dispatch = useDispatch();
  const [openEnquire, setOpenEnquire] = useState(false);
  const [openInvestForm, setOpenInvestForm] = useState(false);
  const [openEnquireForm, setOpenEnquireForm] = useState(false);
  const [currentEnquiry, setCurrentEnquiry] = useState(null);
  const [costCalculateOpen, setCostCalculateOpen] = useState(false);
  const [jetOption, setJetOption] = useState(1);
  const [statusMessage, setStatusMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [priceData, setPriceData] = useState([]);
  const [rangeVal, setRangeVal] = useState(null);
  const [jetTypeList, setJetTypeList] = useState([]);
  const { privateJetRes, privateJetAddRes } = useSelector(
    state => state.common
  );
  const [amount, setAmount] = React.useState("");
  const [step, setStep] = React.useState(1);
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    countryCode: "971",
    phone: "",
    "jetName": "",
    "capacity": 0,
    "type": "",
    "year": "",
    "purpose": "",
    "budgetMin": 0,
    "budgetMax": 0
  });
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "971",
    "shares": 1,
    "jetId": "",
    "sharePrice": 0
  })
  const [loader, setLoader] = useState(true);
  const [bannerImage, setBannerImage] = useState(null);
  const [investFormLoader, setInvestFormLoader] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const [openValid, setOpenValid] = useState(false);
  const handleCloseEnquire = () => setOpenEnquire(false);
  const handleCloseInvestForm = () => setOpenInvestForm(false);
  const handleOpenInvestForm = () => setOpenInvestForm(true);
  const handleOpenEnquire = (val) => {
    setOpenEnquire(true);
    setCurrentEnquiry(val);
  }

  useEffect(() => {
    setLoader(true);
    dispatch(getPrivateJetList());
  }, [dispatch])

  // handle response
  useEffect(() => {
    if (!privateJetRes) return;      // wait until we have a response
    setLoader(false);                        // stop loading no matter success/fail
    localStorage.setItem("currencyType", privateJetRes?.displayCurrency?.type ? privateJetRes?.displayCurrency?.type : "image");
    localStorage.setItem("currencyImage", privateJetRes?.displayCurrency?.value ? privateJetRes?.displayCurrency?.value : "images/bannerImage/1758795455186.svg");
    if (privateJetRes.status === 1) {
      setServiceList(privateJetRes.responseData ?? []);
      setPriceData(privateJetRes?.priceData?.priceList ?? []);
      setBannerImage(privateJetRes?.jetBannerImage);
      setRangeVal(privateJetRes?.priceData ?? {
        "minPrice": 0,
        "maxPrice": 1000000,
        "step": 1000
      })
      setJetTypeList(privateJetRes?.jetTypeList ?? []);
    } else {
      setServiceList([]);
      setJetTypeList([]);
      setPriceData([]);
      setRangeVal(null);
      setBannerImage(null);
    }
  }, [privateJetRes]);

  const onOrderNow = () => {
    setOpenEnquire(false);
    setOpenEnquireForm(true);
  }

  const handleCostCalculate = (val) => {
    const obj = {
      "name": val?.name,
      "email": val?.email,
      "countryCode": val?.countryCode,
      "phone": val?.phone,
      "passengerId": sessionStorage.getItem("rslkeyId") || null,
      "enquiryType": 2,
      "shares": val?.shares,
      "jetId": val?.jetId,
      "totalShareCost": (Number(val?.shares) * Number(val?.sharePrice))
    }
    setFormLoader(true);
    dispatch(getPrivateJetAdd(obj));
  }

  const handleFormSubmit = (data) => {
    const obj = {
      ...data,
      jetType: jetOption,
      enquiryType: 1,
      passengerId: sessionStorage.getItem("rslkeyId") || null
    }
    setFormLoader(true);
    dispatch(getPrivateJetAdd(obj));
  }

  const reset = () => {
    setFormData({
      name: "",
      email: "",
      countryCode: "971",
      phone: "",
      "jetName": "",
      "capacity": 0,
      "type": "",
      "year": "",
      "purpose": "",
      "budgetMin": 0,
      "budgetMax": 0
    });
    setValues({
      name: "",
      email: "",
      phone: "",
      countryCode: "971",
      "shares": 1,
      "jetId": "",
      "sharePrice": 0

    })
    setFormLoader(false);
    setJetOption(1);
    setOpenEnquireForm(false);
    setCostCalculateOpen(false);
  }

  useEffect(() => {
    if (privateJetAddRes) {
      setFormLoader(false);
      setInvestFormLoader(false);
      setLoader(false);
      if (privateJetAddRes?.status === 1) {
        setOpenValid(true);
        setStatus(privateJetAddRes?.status)
        setStatusMessage(privateJetAddRes?.message)
      } else {
        setStatus(-1);
        setStatusMessage(privateJetAddRes?.message || "An error occurred, please try again.");
        setOpenValid(true);
      }
    }
  }, [privateJetAddRes])

  const handleCloseValid = () => {

    console.log("status", status);

    if (status === 1) {
      reset();
      setStep(1);
      setAmount("");
      handleCloseInvestForm();
    }

    setOpenValid(false);
    setStatusMessage("");
    setStatus(null);
  }

  const handleCostCalculateOpen = () => {
    setCostCalculateOpen(true);
  }

  const handleCloseOrderJet = () => {
    setCostCalculateOpen(false);
    setOpenEnquireForm(false);
    handleCloseValid();
    reset();
  }



  const handleInvestFormSubmit = (value) => {
    const obj = {
      ...value,
      enquiryType: 3,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    setInvestFormLoader(true);
    dispatch(getPrivateJetAdd(obj));
  }

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section className="hero" style={{
        position: "relative",
        width: "100%",
        height: bannerHeight(),
        overflow: "hidden",
      }}>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          {/* BG image */}
          <Image
            // src="/img/investments/privatejet/banner.svg"
            src={bannerImage ? `${process.env.IMAGE_BASE_URL}/${bannerImage}` : "/img/investments/privatejet/banner.svg"}
            alt="PrivateJet"
            fill
            priority
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          {/* Gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              background: "linear-gradient(to top, #00000082 0%, rgba(0, 0, 0, 0) 20%)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* dark gradient overlay */}
          {/* <div className="overlay" aria-hidden="true" /> */}

          {/* content */}
          <div className="content">
            <h1 className="title jura">
              <span className="scribble-wrap">
                <span className="scribble-text">Invest</span>
                {/* teal hand-drawn oval */}
                <img
                  src="/img/header/Oval.svg"
                  alt=""
                  className="scribble"
                />
              </span>{" "}
              in Private Jet
            </h1>

            <div className="cta">
              <CtaButton label="Check Fleet" onClick={() => scrollToId("fleet")} endIconSrc="/img/header/VectorDown.svg" />
              {/* <CtaButton cta={{ label: "Check Fleet", href: "#fleet" }} onClick={() => scrollToId("fleet")} endIconSrc="/img/header/VectorDown.svg" /> */}
            </div>
          </div>
        </div>
      </section>
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
        }}
      >
        <Box id="fleet" sx={{ scrollMarginTop: { xs: '80px', md: '96px' }, background: "#fff" }}>
          <PickYourPrivateJet loader={loader} data={{
            ...PRIVATE_JET_PAGE?.carToInvest,
            jetData: serviceList || []
          }} endIconSrc="/img/header/VectorDown.svg" onDown="investmentGuide" orderJet={(val) => handleOpenEnquire(val)} costCalculate={handleCostCalculateOpen} />
        </Box>
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <RoiInvestorBenefits data={PRIVATE_JET_PAGE?.roiInvestorBenefits} onClick={(val) => handleOpenInvestForm()} />
        </Box>
        <Box sx={{ background: "#fff" }}>
          <CommunicationChannel data={PRIVATE_JET_PAGE.communicationChannel} />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.35em;
          top: 5px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

      <BookaCallEnquiry
        setJetOption={setJetOption}
        jetOption={jetOption}
        options={
          [
            {
              label: "Commercial Jet",
              value: 2
            }, {
              label: "Private Jet",
              value: 1
            }
          ]
        }
        onWhatsapp={(title) => openWhatsAppChat(`${title}`, "booking")}
        openEnquire={openEnquire}
        handleCloseEnquire={handleCloseEnquire}
        onOrderNow={onOrderNow}
      />
      <BookaCallEnquiryForm jetTypeList={jetTypeList} rangeVal={rangeVal} formData={formData} setFormData={setFormData} open={openEnquireForm} data={serviceList} loader={formLoader} onClose={handleCloseOrderJet} onSubmit={(data) => handleFormSubmit({ ...data })} />

      <InvestmentSimulatorFlow
        open={costCalculateOpen}
        onClose={handleCloseOrderJet}
        onInvest={(p) => handleCostCalculate(p)}
        setValues={setValues}
        values={values}
        formLoader={formLoader}
        setStep={setStep}
        step={step}
        amount={amount}
        setAmount={setAmount}
        priceData={priceData}
      />

      <AfterFormSubmit open={openValid} status={status} message={statusMessage} onClose={handleCloseValid} />
      <InvestNow
        open={openInvestForm}
        onClose={handleCloseInvestForm}
        fleetCard={serviceList}
        handleSubmit={handleInvestFormSubmit}
        loader={investFormLoader}
        setLoader={setInvestFormLoader}
        labels={["Name", "Email", "Phone", "Select Jet", "Document"]}
        apiResponse={null}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}